import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const SmartQuoteWorkspaceRouteLazy = lazyWithRetry(() => import('./workspace'));
export function SmartQuoteWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback className="flex-grow-1" />}>
      <SmartQuoteWorkspaceRouteLazy />
    </Suspense>
  );
}
